@if (isVisible()) {
  <div class="flex">
    <mat-toolbar class="mat-toolbar-flex bg-blue-300 border-solid border-1">
      @if (homeVisible()) {
        <button
          class="btn" [class.btn-home]="true"
          id="home"
          (click)="goHome($event)"
          [disabled]="homeDisabled()"
          matTooltip="回首頁"
        >
          <mat-icon fontIcon="home" slot="start"></mat-icon>
        </button>
      }
      @if (backVisible()) {
        <button
          class="btn" [class.btn-primary]="true"
          (click)="goBack($event)"
          [disabled]="backDisabled()"
          matTooltip="回上頁"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>
      }
      @if (queryVisible()) {
        <button
          (click)="doQuery($event)"
          [disabled]="queryDisabled"
          class="btn"
          [class.btn-disabled]="queryDisabled"
          [class.btn-query]="!queryDisabled"
          matTooltip="查詢"
        >
          <mat-icon
            fontIcon="search"
            slot="start"
            name="search-circle-outline"
          ></mat-icon>
        </button>
      }
      @if (insertVisible()) {
        <button
          (click)="doInsert($event)"
          [disabled]="insertDisabled"
          class="btn"
          [class.btn-disabled]="insertDisabled"
          [class.btn-insert]="!insertDisabled"
          matTooltip="新增"
        >
          <mat-icon fontIcon="add" slot="start" name="add-outline"></mat-icon>
        </button>
      }
      @if (editVisible()) {
        <button
          (click)="doEdit($event)"
          [disabled]="editDisabled"
          class="btn"
          [class.btn-disabled]="editDisabled"
          [class.btn-edit]="!editDisabled"
          matTooltip="修改"
        >
          <mat-icon
            fontIcon="edit"
            slot="start"
            name="create-outline"
          ></mat-icon>
        </button>
      }
      @if (postVisible()) {
        <button
          (click)="doPost($event)"
          [disabled]="postDisabled"
          matTooltip="確定"
          class="btn"
          [class.btn-disabled]="postDisabled"
          [class.btn-post]="!postDisabled"
        >
          <mat-icon
            fontIcon="done"
            slot="start"
            name="checkmark-outline"
          ></mat-icon>
        </button>
      }
      @if (cancelVisible()) {
        <button
          (click)="doCancel($event)"
          [disabled]="cancelDisabled"
          class="btn"
          [class.btn-disabled]="cancelDisabled"
          [class.btn-cancel]="!cancelDisabled"
          matTooltip="取消"
        >
          <mat-icon
            fontIcon="cancel"
            slot="start"
            name="close-outline"
          ></mat-icon>
        </button>
      }
      @if (deleteVisible()) {
        <button
          (click)="doDelete($event)"
          [disabled]="deleteDisabled"
          class="btn"
          [class.btn-disabled]="deleteDisabled"
          [class.btn-delete]="!deleteDisabled"
          matTooltip="刪除"
        >
          <mat-icon
            fontIcon="delete"
            slot="start"
            name="trash-outline"
          ></mat-icon>
        </button>
      }
      <!-- <app-jkcombobox [(value)]="uiMode" [items]="uiModeList" [matTooltip]="'明細UI模式'"></app-jkcombobox> -->
      <button
        class="btn"
        (click)="doHelp($event)"
        [disabled]="false"
        matTooltip="說明"
      >
        <mat-icon fontIcon="help" slot="start" name="help-outline"></mat-icon>
      </button>
    </mat-toolbar>
    <mat-toolbar class="mat-toolbar-flex bg-blue-300 border-1">
      <button
        class="btn"
        id="tools"
        [cdkMenuTriggerFor]="menu"
        matTooltip="工具"
      >
        <mat-icon fontIcon="build_circle" slot="start"></mat-icon>
      </button>
      @if (editAndSaveVisible()) {
        <button class="btn" [class.btn-editAndSave]="true" (click)="doEditAndSave($event)">
          存檔
        </button>
      }
      @if (confirmVisible) {
        <button
          (click)="doConfirm($event)"
          [disabled]="confirmDisabled"
          class="btn"
          [class.btn-disabled]="confirmDisabled"
          [class.btn-confirm]="!confirmDisabled"
          matTooltip="確認"
        >
          <mat-icon
            fontIcon="approval"
            slot="start"
            name="checkmark-outline"
          ></mat-icon>
        </button>
      }
      @if (cancelConfirmVisible) {
        <button
          (click)="doCancelConfirm($event)"
          [disabled]="cancelConfirmDisabled"
          class="btn"
          [class.btn-disabled]="cancelConfirmDisabled"
          [class.btn-cancel-confirm]="!cancelConfirmDisabled"
          matTooltip="取消確認"
        >
          <mat-icon
            fontIcon="unpublished"
            slot="start"
            name="close-outline"
          ></mat-icon>
        </button>
      }
      @if (voidVisible) {
        <button
          (click)="doVoid($event)"
          [disabled]="voidDisabled"
          class="btn"
          [class.btn-disabled]="voidDisabled"
          [class.btn-void]="!voidDisabled"
          matTooltip="作廢"
        >
          <mat-icon fontIcon="block" slot="start" name="ban-outline"></mat-icon>
        </button>
      }
      @if (printVisible) {
        <button
          class="btn"
          (click)="doPrint($event)"
          [disabled]="printDisabled"
          [class.btn-disabled]="printDisabled"
          [class.btn-post]="!printDisabled"
          matTooltip="列印"
        >
          <mat-icon
            fontIcon="print"
            slot="start"
            name="print-outline"
          ></mat-icon>
        </button>
      }
      @if (attachVisible) {
        <button
          (click)="doAttach($event)"
          [disabled]="attachDisabled"
          class="btn"
          [class.btn-disabled]="attachDisabled"
          [class.btn-attach]="!attachDisabled"
          matTooltip="附件"
        >
          <mat-icon
            fontIcon="attach_file"
            slot="start"
            name="attach-outline"
          ></mat-icon>
        </button>
      }
      @if (user1Visible) {
        <button
          class="btn"
          id="u1"
          (click)="user1($event)"
          [disabled]="user1Disabled()"
        >
          {{ userCaption1 }}
        </button>
      }
      @if (user2Visible) {
        <button
          class="btn"
          id="u2"
          (click)="user2($event)"
          [disabled]="user2Disabled()"
        >
          {{ userCaption2 }}
        </button>
      }
      @if (user3Visible) {
        <button
          class="btn"
          id="u3"
          (click)="user3($event)"
          [disabled]="user3Disabled()"
        >
          {{ userCaption3 }}
        </button>
      }
      @if (user4Visible) {
        <button
          class="btn"
          id="u4"
          (click)="user4($event)"
          [disabled]="user4Disabled()"
        >
          {{ userCaption4 }}
        </button>
      }
    </mat-toolbar>

    @if (navigateVisible()) {
      <mat-toolbar>
        @if (firstVisible()) {
          <button
            class="btn"
            (click)="onFirstRow()"
            matTooltip="第一筆"
            [disabled]="firstDisabled"
          >
            <mat-icon>first_page</mat-icon>
          </button>
        }
        @if (previousVisible) {
          <button
            class="btn"
            (click)="onPreviousRow()"
            matTooltip="上一筆"
            [disabled]="previousDisabled"
          >
            <mat-icon>navigate_before</mat-icon>
          </button>
        }
        @if (nextVisible) {
          <button
            class="btn"
            (click)="onNextRow()"
            matTooltip="下一筆"
            [disabled]="nextDisabled"
          >
            <mat-icon>navigate_next</mat-icon>
          </button>
        }
        @if (lastVisible) {
          <button
            class="btn"
            (click)="onLastRow()"
            matTooltip="最後一筆"
            [disabled]="lastDisabled"
          >
            <mat-icon>last_page</mat-icon>
          </button>
        }
      </mat-toolbar>
    }
  </div>
}

<ng-template #menu class="example-menu-bar-item">
  <div class="example-menu" cdkMenu>
    <button class="example-menu-bar-item" cdkMenuItem (click)="user1($event)">
      {{ userCaption1 }}
    </button>
    <button class="example-menu-bar-item" cdkMenuItem (click)="user2($event)">
      {{ userCaption2 }}
    </button>
    <button class="example-menu-bar-item" cdkMenuItem (click)="user3($event)">
      {{ userCaption3 }}
    </button>
    <button class="example-menu-bar-item" cdkMenuItem (click)="user4($event)">
      {{ userCaption4 }}
    </button>
  </div>
</ng-template>
